import React, { PropsWithChildren } from 'react';
import Box from '../Box/Box';

type TActionIcons = PropsWithChildren & {
  alwaysVisible?: boolean;
};

const ActionIcons = ({ children, alwaysVisible = false }: TActionIcons) => {
  const boxClassName = alwaysVisible ? 'hz-Image-icons hz-Image-icons--always-visible' : 'hz-Image-icons';

  return (
    <Box name="image-Action-icons" as="div" className={boxClassName}>
      {children}
    </Box>
  );
};

export default ActionIcons;
